import React from 'react';
import { MustIncludeOneOfBasicTestIdWithIdProps } from '../common/internal/test-id.types';
import HBButtonGroup, {
    Props as HBButtonGroupProps
} from '../HBButtonGroup/HBButtonGroup';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';

export interface HBButtonGroupFieldProps
    extends Omit<HBButtonGroupProps & HBBaseFormFieldProps, 'size' | 'id'> {
    /** Enables DS Next visual styling (updated disabled colors and alignment). Temporary — will be removed post-migration. @deprecated */
    isDSNext?: boolean;
}

const HBButtonGroupField = (
    props: HBButtonGroupFieldProps & MustIncludeOneOfBasicTestIdWithIdProps
) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps}>
            <HBButtonGroup {...inputProps} testIdName={inputProps.testIdName} />
        </HBBaseFormField>
    );
};

export default HBButtonGroupField;
